export default "__VITE_ASSET__BlomLc_Q__"